import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateLinkMutation } from "../graphql/mutations";
import type {
  CreateLinkMutationType,
  CreateLinkMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateLinkMutation = (
  options?: MutationHookOptions<
    CreateLinkMutationType,
    CreateLinkMutationVariablesType
  >
) => {
  return useMutation<CreateLinkMutationType, CreateLinkMutationVariablesType>(
    CreateLinkMutation,
    options
  );
};
